import fade from './fade'
import zoom from './zoom'

export default {
	fade,
	zoom,
}
